import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { ClientStatusList } from 'actions/actionTypes';
import * as actions from 'actions/clientStatus/list';

import { callClientStatusList } from 'network/apis/clientStatus/list';

function* loadClientStatusListRequestSaga() {
    try {
        const manager = yield select((state) => state.manager);

        const data = {
            sort: 0,
        };

        const response = yield call(callClientStatusList, manager.manager.shopGuid, data);

        yield put(actions.loadClientStatusListRequestSuccess(response.data));
    } catch (error) {
        yield put(actions.loadClientStatusListRequestFailure(error.message));
    }
}

// Sign-In Sagas
export default function* root() {
    yield all([takeLatest(ClientStatusList.LOAD_CLIENT_STATUS_LIST_REQUEST, loadClientStatusListRequestSaga)]);
}
